import React from 'react';
import Apple from '../icons/Apple.svg'
import Amazon from '../icons/Amazon.svg'
import Cuview from '../icons/CUVIEW.svg'
import Spotify from '../icons/SPOTIFY.svg'
import Deezer from '../icons/DEEZER.svg'
import Pandora from '../icons/PANDORA.svg'
import teIcon from '../icons/Te.svg'
import externalLink from '../icons/externalLinks.svg'
import QRCode from "react-qr-code";
import merchIcon from '../icons/merchbar_logo_white.svg'
import { useNavigate } from 'react-router-dom';



const AnalyzeBody = ( props ) => {

    const navigate = useNavigate()

    const iconClickHandler = (url) =>{

        window.open(url)
    }

    const memberClickHandler = (member) => {
        navigate(`/filter_results/${member.id}!7`)
    }

    return (
        <>
            { props.activeData && props.activeData.album ?
                <div className = "w-100 mx-auto px-3 pb-3 d-flex flex-column flex-lg-row analyze-body">
                    <div className='col-12 col-lg-9 pb-3 d-flex flex-column flex-md-row flex-lg-row align-items-center align-items-md-start'>
                        <div className = "col-5 mx-auto mx-md-0 p-1 col-lg-3 col-md-5 text-center">
                            <img
                                src = {props.activeData.album.cover_url} alt=""
                                role="button"
                                onClick = {() => iconClickHandler(props.activeData.album.url)}
                                className = "w-100 shadow-lg"
                                style={{objectFit:"cover"}}
                                />
                        </div>
                        <div className='col-11 col-lg-8 col-md-7 ps-md-4 ps-lg-5 pt-2 d-flex flex-column justify-content-between'>
                            <div className = "col-12 text-start">
                                <div className='w-100 d-flex text-center align-items-center justify-content-center justify-content-md-start'>
                                    <div className="fw-bold text-white pe-3 text-start analyze-title"
                                        role="button"
                                        onClick = {() => iconClickHandler(props.activeData.track_url)}
                                    >
                                        {props.activeData.track_title}
                                    </div>
                                    <img
                                        className='analyze-icon-te'
                                        src = {teIcon}
                                        alt = ""
                                        role = "button"
                                        onClick={()=>window.open(`https://te.cugate.com/?act=track_culink&ref=album&ids=${props.activeData.track_id};&tracksnum=1&album_id=${props.activeData.album.id}&link_type=Extra+Link`)}
                                    />
                                </div>

                                {
                                    props.analyzeGenre &&
                                    <div className="fw-bold text-white analyze-title"
                                        role="button"
                                    >
                                        Genre: {props.analyzeGenre}
                                    </div>
                                }
                                {
                                    props.analyzeMood &&
                                    <div className="fw-bold text-white analyze-title"
                                        role="button"
                                    >
                                        Mood: {props.analyzeMood}
                                    </div>
                                }
                                {
                                    props.activeData && props.activeData.members ?
                                    props.activeData.members.map((member, index)=>
                                    <div className='d-flex align-items-center py-1 justify-content-between pe-2' key={index}>
                                        <div
                                            className = "col-9 text-white pt-0 pt-lg-2 text-wrap"
                                            role="button"
                                            onClick = {() => memberClickHandler(member)}>
                                            {member.title2}
                                        </div>
                                        <div className='col-3 d-flex justify-content-end'>
                                            <img
                                                className='analyze-icon-member ps-0'
                                                src = {merchIcon}
                                                role = "button"
                                                onClick={()=>iconClickHandler(member.merch_url)}
                                                alt = ""/>
                                            <img
                                                className='analyze-icon-member'
                                                style={{ marginLeft:"0.5rem" }}
                                                src = {teIcon}
                                                alt = ""
                                                role = "button"
                                                onClick={()=>window.open(`https://te.cugate.com/index.php?act=member_view&ref=members&ids=${member.id};&membersnum=1`)}
                                            />
                                        </div>
                                    </div>) : ""
                                }
                            </div>
                            <div className='d-flex w-100 overflow-hidden flex-wrap justify-content-center justify-content-md-start justify-content-lg-start'>
                                {
                                    props.activeData.culinks && props.activeData.culinks.EXTRA_LINKS &&
                                    props.activeData.culinks.EXTRA_LINKS.length ?
                                    props.activeData.culinks.EXTRA_LINKS.map((link, index) =>
                                    <div className='d-flex col-6 align-items-center pb-3' key={index}>
                                        <img
                                            className='border rounded analyze-icon-thumb'
                                            src = {link.link_img_url_300}
                                            alt = ""
                                            role = "button"
                                        />
                                        <div className = "ps-3">
                                            <div
                                                className = "text-white"
                                                role="button"
                                                onClick = {() => iconClickHandler(link.link_url)}>
                                                {link.link_title}
                                            </div>
                                            <div className='d-flex align-items-center'>
                                                <img
                                                    src = {externalLink}
                                                    alt = ""
                                                    className='analyze-icon-external'
                                                    />
                                                <div
                                                    className='text-info ps-2'
                                                    onClick={() => iconClickHandler(link.link_url)}
                                                    role="button"
                                                >
                                                    {
                                                        new URL(link.link_url).hostname
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    )
                                    : ""
                                }
                                {
                                    props.activeData.links && props.activeData.links.length ?
                                    props.activeData.links.map((link, index) =>
                                    <div className='d-flex col-6 align-items-center pb-3' key={index}>
                                        <img
                                            className='border rounded analyze-icon-thumb'
                                            src = {link.link_img_url}
                                            alt = ""
                                            role = "button"
                                        />
                                        <div className = "ps-3">
                                            <div
                                                className = "text-white"
                                                role="button"
                                                onClick = {() => iconClickHandler(link.link_url)}>
                                                {link.link_title}
                                            </div>
                                            <div className='d-flex align-items-center'>
                                                <img
                                                    src = {externalLink}
                                                    alt = ""
                                                    className='analyze-icon-external'
                                                    />
                                                <div
                                                    className='text-info ps-2'
                                                    onClick={() => iconClickHandler(link.link_url)}
                                                    role="button"
                                                >
                                                    {
                                                        new URL(link.link_url).hostname
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    )
                                    : ""
                                }
                                {
                                    props.activeData.salome_obj_links && props.activeData.salome_obj_links.length ?
                                    props.activeData.salome_obj_links.map((link, index) =>
                                    <div className='d-flex col-6 align-items-center pb-3' key={index}>
                                        <img
                                            className='border rounded analyze-icon-thumb'
                                            src = {link.link_img_url}
                                            alt = ""
                                            role = "button"
                                        />
                                        <div className = "ps-3">
                                            <div
                                                className = "text-white"
                                                role="button"
                                                onClick = {() => iconClickHandler(link.link_url)}>
                                                {link.link_title}
                                            </div>
                                            <div className='d-flex align-items-center'>
                                                <img
                                                    src = {externalLink}
                                                    alt = ""
                                                    className='analyze-icon-external'
                                                    />
                                                <div
                                                    className='text-info ps-2'
                                                    onClick={() => iconClickHandler(link.link_url)}
                                                    role="button"
                                                >
                                                    {
                                                        new URL(link.link_url).hostname
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    )
                                    : ""
                                }
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-lg-3 col-md-8 pt-3 pt-md-4 pt-lg-0'>
                        {
                            props.activeData.culinks ?
                            <div className = "col-10 col-md-12 col-lg-8 mx-auto mx-md-0 mx-lg-0 d-flex justify-content-center">
                                <img
                                    className = "analyze-streaming-icon pe-3 pe-md-3 pe-lg-2"
                                    src = {Apple}
                                    role = "button"
                                    alt = ''
                                    onClick = {() => iconClickHandler(props.activeData.culinks.ITUNES.url)}
                                    />
                                <img
                                    className = "analyze-streaming-icon pe-3 pe-md-3 pe-lg-2"
                                    src = {Amazon}
                                    role = "button"
                                    alt = ''
                                    onClick = {() => iconClickHandler(props.activeData.culinks.AMAZON.url)}/>
                                <img
                                    className = "analyze-streaming-icon pe-3 pe-md-3 pe-lg-2"
                                    src = {Cuview}
                                    role = "button"
                                    alt = ''
                                    onClick = {() => iconClickHandler(props.activeData.culinks.CUVIEW.url)}/>
                                <img
                                    className = "analyze-streaming-icon pe-3 pe-md-3 pe-lg-2"
                                    src = {Spotify}
                                    role = "button"
                                    alt = ''
                                    onClick = {() => iconClickHandler(props.activeData.culinks.SPOTIFY.url)}/>
                                <img
                                    className = "analyze-streaming-icon pe-3 pe-md-3 pe-lg-2"
                                    src = {Deezer}
                                    role = "button"
                                    alt = ''
                                    onClick = {() => iconClickHandler(props.activeData.culinks.DEEZER.url)}/>
                                <img
                                    className = "analyze-streaming-icon pe-3 pe-md-3 pe-lg-2"
                                    src = {Pandora}
                                    role = "button"
                                    alt = ''
                                    onClick = {() => iconClickHandler(props.activeData.culinks.RDIO.url)}/>
                            </div> : ""
                        }
                        <div
                        className='mt-3 mt-lg-5 mt-md-5 col-4 col-md-6 col-lg-4 mx-auto mx-md-0 mx-lg-0'
                        style={{ height: "auto", background:"rgba(255, 255, 255)", opacity:"0.7", padding:"0.7rem", border:"2px", borderRadius:"0.5rem"}}>
                            <QRCode
                                size={256}
                                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                value={props.activeData && props.activeData.wm1_info && props.activeData.wm1_info.code && props.activeData.wm1_info.code === '2147392886' ? 'https://shop.rewe.de/p/nutella-750g/5095220' : props.resultLink}
                                viewBox={`0 0 256 256`}
                            />
                        </div>
                    </div>
                </div> : ""
            }
        </>
    );
}

export default AnalyzeBody;